import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-overview-page',
  templateUrl: './courses-overview-page.component.html',
  styleUrls: ['./courses-overview-page.component.css']
})
export class CoursesOverviewPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
